<template>
    <div>
        <chapter-navigation :UserSubmissionData='getUserSubmissionData' :chapterdata='getChapterData'></chapter-navigation>
        <router-view :UserSubmissionData='getUserSubmissionData' :chapterdata='getChapterData'></router-view>
    </div>
</template>

<script>
import ChapterNavigation from './ChapterNavigation.vue'
import { store } from '../../../store/store.js'

export default {
    components: {
      ChapterNavigation
    },
    props:['UserSubmissionData'],
    methods: {

    },
    computed: {
        getChapterData() {
            var chapterId = parseInt(this.$route.params.chapterId);
            //var asd = this.$store.getters.getCurrentChapterData()
            var asd2 = this.$store.getters.getCurrentChapterData2(chapterId)
            return asd2;    
        },
        getUserSubmissionData(){

            return this.UserSubmissionData
        }
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/course/chapter/Chapter.vue